// =====================================================================================
// INVRT Radar - web console - a site's mode, in the tenant's own words (story O8)
//
// The ONE client-side home for the plan-type mapping. The mode is a site row's
// provider_plan_type rendered the way the tenant bought it: the exact mirror of
// routes/sites.ts's tenantPlanType (which stays the server's own copy, out of scope
// here). Every surface that forks on the mode imports this function, so the two can
// never drift: the visitors table (pages/site/VisitorsPanel.tsx) and the contact
// dossier (pages/contacts/ContactDrawer.tsx).
// =====================================================================================

/**
 * The site's mode in the tenant's own words, from the site row's provider_plan_type.
 * employee to b2b, consumer to b2c, anything else (the mode is not set yet, or the site
 * read has not landed) to null - and null falls open to today's person-first order on
 * every surface, so an unset mode can never rewrite a screen.
 */
export function siteModeOf(providerPlanType: string | null | undefined): "b2b" | "b2c" | null {
  if (providerPlanType === "employee") return "b2b";
  if (providerPlanType === "consumer") return "b2c";
  return null;
}
